import styled, { css } from 'styled-components';
import { AccordionSize, AccordionStyle } from '.';
import { construirSombra } from '@/styles/theme';

export type ContainerProps = {
  $size: AccordionSize;
  $style: AccordionStyle;
};

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;

  flex: 1;

  ${({ theme, $style }) => {
    if (['bordered', 'ghost'].includes($style)) return '';
    return css`
      background-color: ${theme.panel[$style]};
      box-shadow: ${construirSombra('shadow_3')};
    `;
  }}

  ${({ theme, $style, $size }) => {
    if ($style === 'ghost')
      return css`
        padding-top: ${theme.spacing[$size]}px;
        padding-bottom: ${theme.spacing[$size]}px;
      `;
    return css`
      padding-left: ${theme.spacing[$style === 'solid' ? '4' : '2']}px;
      padding-right: ${theme.spacing[$style === 'solid' ? '4' : '2']}px;
      padding-top: ${theme.spacing[$size]}px;
      padding-bottom: ${theme.spacing[$size]}px;
    `;
  }};

  ${({ theme, $style }) => {
    if ($style === 'ghost') return '';
    return css`
      border-radius: ${theme.radius['4']}px;
    `;
  }}

  ${({ theme, $style }) => {
    if ($style !== 'bordered') return '';
    return css`
      border: 2px solid ${theme.colors.neutral.neutral_alpha['6']};
    `;
  }}
`;
